import { todayUpdates, hotRankList } from "@/mocks/portal";

export default function TodaySection() {
  return (
    <section id="today" className="scroll-mt-20 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-time-line" />
              今日更新
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热点速览
            </h2>
            <p className="mt-2 text-sm text-foreground-600">汇总今日最新爆料与动态，第一时间跟上吃瓜节奏。</p>
          </div>
          <a
            href="/latest"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 sm:inline-flex"
          >
            全部动态 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 左：动态流 */}
          <div className="lg:col-span-8">
            <ol className="relative space-y-4 border-l-2 border-background-300 pl-6">
              {todayUpdates.map((u) => (
                <li key={u.id} className="relative">
                  <span className="absolute -left-[29px] top-1.5 flex h-3 w-3 items-center justify-center rounded-full bg-background-50 ring-2 ring-primary-400" />
                  <a
                    href="/latest"
                    className="block rounded-lg bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:shadow-sm"
                  >
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-xs font-medium text-primary-600">{u.time}</span>
                      {u.badge && (
                        <span className="rounded bg-accent-500 px-1.5 py-0.5 text-[10px] font-bold text-background-50">
                          {u.badge}
                        </span>
                      )}
                      <span className="rounded-full bg-background-100 px-2 py-0.5 text-[10px] text-foreground-600">
                        {u.category}
                      </span>
                    </div>
                    <h3 className="mt-2 text-base font-semibold text-foreground-950 line-clamp-1">{u.title}</h3>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600 line-clamp-2">{u.summary}</p>
                    <div className="mt-2 flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-chat-3-line" />
                      {u.comment.toLocaleString()} 讨论
                    </div>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* 右：实时排行缩略 */}
          <aside className="lg:col-span-4" aria-label="热门排行预览">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                  <span className="flex h-6 w-6 items-center justify-center rounded bg-accent-500 text-background-50">
                    <i className="ri-trophy-line text-xs" />
                  </span>
                  热门排行 TOP5
                </h3>
                <a href="/rankings" className="text-xs font-semibold text-primary-600 hover:text-primary-700">
                  全部
                </a>
              </div>
              <ol className="mt-4 space-y-3">
                {hotRankList.slice(0, 5).map((h) => (
                  <li key={h.id}>
                    <a
                      href="/rankings"
                      className="flex items-center gap-3 rounded-lg p-2 transition-colors hover:bg-background-100"
                    >
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                          h.rank === 1
                            ? "bg-primary-500 text-background-50"
                            : h.rank === 2
                              ? "bg-accent-500 text-background-50"
                              : h.rank === 3
                                ? "bg-secondary-500 text-background-50"
                                : "bg-background-100 text-foreground-700"
                        }`}
                      >
                        {h.rank}
                      </span>
                      <span className="flex-1 text-sm font-medium text-foreground-800 line-clamp-1">{h.title}</span>
                      <span className="flex flex-col items-end gap-0.5">
                        <span className="text-xs text-foreground-500">{h.heat}</span>
                        <span className={`flex items-center text-[10px] ${h.trend === "up" ? "text-primary-600" : h.trend === "down" ? "text-secondary-700" : "text-foreground-400"}`}>
                          {h.trend === "up" && <i className="ri-arrow-up-line" />}
                          {h.trend === "down" && <i className="ri-arrow-down-line" />}
                          {h.trend === "flat" && <i className="ri-subtract-line" />}
                          {h.delta}
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}